import { render, staticRenderFns } from "./CustomerFormProductionEmbeddable.vue?vue&type=template&id=73b04c42&"
import script from "./CustomerFormProductionEmbeddable.vue?vue&type=script&lang=js&"
export * from "./CustomerFormProductionEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports